import React from 'react';
import styles from './terms-of-service.module.scss';
import { HeaderMenu } from '@/components/header-menu';
import { routesApp } from '@/constans/routes';
import { Typography } from '@/ui-kit';
import { Trans, useTranslation } from 'react-i18next';

const TermsOfService = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <HeaderMenu
                className={styles.headerMenu}
                headerBg="white"
                isFixed>
                <Typography
                    variant="p"
                    fontWeight="medium"
                    className={styles.header__title}
                    center>
                    {t('terms.terms_title')}
                </Typography>
            </HeaderMenu>

            <div className={styles.content}>
                <h3>
                    <strong>{t('terms.general_provisions')}</strong>
                </h3>
                <div>
                    <ul>
                        <li>
                            <p>{t('terms.service_designed_for')}</p>
                        </li>
                        <li>
                            <p>{t('terms.user_obliged')}</p>
                        </li>
                        <li>
                            <p>
                                {t('terms.admin_reserves_right_to_block_accounts')}
                            </p>
                        </li>
                    </ul>
                </div>

                <h3>
                    <strong>{t('terms.signup_and_profile')}</strong>
                </h3>
                <p>{t('terms.prohibited')}</p>
                <ul>
                    <li>
                        <p>{t('terms.using_people_data')}</p>
                    </li>
                    <li>
                        <p>{t('terms.creation_of_fake_profiles')}</p>
                    </li>
                    <li>
                        <p>{t('terms.providing_false_info')}</p>
                    </li>
                    <li>
                        <p>{t('terms.profile_photos_must')}</p>
                        <ul>
                            <li>
                                <p>{t('terms.be_relevant_and_clear')}</p>
                            </li>
                            <li>
                                <p>{t('terms.show_face')}</p>
                            </li>
                            <li>
                                <p dangerouslySetInnerHTML={{ __html: t('terms.formats') }} />
                            </li>
                            <li>
                                <p>{t('terms.prohibited_secondary')}</p>
                            </li>
                        </ul>
                    </li>
                </ul>

                <h3>
                    <strong>{t('terms.communication_and_behavior')}</strong>
                </h3>
                <p>{t('terms.prohibited_tertiary')}</p>
                <ul>
                    <li>
                        <p>{t('terms.insults_threats_harassment')}</p>
                    </li>
                    <li>
                        <p>{t('terms.sending_spam_advertising_links')}</p>
                    </li>
                    <li>
                        <p>{t('terms.attempts_to_deceive')}</p>
                    </li>
                    <li>
                        <p>{t('terms.chatsContent')}</p>
                    </li>
                </ul>

                <h3>
                    <strong>{t('terms.security')}</strong>
                </h3>

                <ul>
                    <li>
                        <p>{t('terms.not_share_personal_info')}</p>
                    </li>
                    <li>
                        <p>{t('terms.beware_of_scammers')}</p>
                    </li>
                    <li>
                        <p>{t('terms.content_distributtion')}</p>
                    </li>
                </ul>

                <h3>
                    <strong>{t('terms.moderation_and_complaints')}</strong>
                </h3>

                <ul>
                    <li>
                        <p>{t('terms.admin_does_not_guarantee_security')}</p>
                    </li>
                    <li>
                        <p>{t('terms.violators_are_blocked')}</p>
                    </li>
                    <li>
                        <p dangerouslySetInnerHTML={{ __html: t('terms.complain_note') }} />
                    </li>
                </ul>

                <h3>
                    <strong>{t('terms.tech_requirements')}</strong>
                </h3>

                <ul>
                    <li>
                        <p>
                            <Trans i18nKey="terms.photo_size_note" />
                        </p>
                    </li>
                    <li>
                        <p>{t('terms.auto_delete')}</p>
                        <ul>
                            <li>
                                <p>{t('terms.bad_quality_img')}</p>
                            </li>
                            <li>
                                <p>{t('terms.photos_with_other_people')}</p>
                            </li>
                        </ul>
                    </li>
                </ul>

                <h3>
                    <strong>{t('terms.final_provisions')}</strong>
                </h3>

                <ul>
                    <li>
                        <p>
                            <Trans i18nKey="terms.admin_can_change_rules" />
                        </p>
                        <p>
                            <Trans i18nKey="terms.review_current_version_rules" />
                        </p>
                    </li>
                    <li>
                        <p>
                            {t('terms.you_agree_to_processing_of_your_data')}
                        </p>
                    </li>
                </ul>

                <h3>
                    <strong>{t('terms.confidentiality_and_info_protection')}</strong>
                </h3>

                <ol>
                    <li>{t('terms.personal_data_processing')}</li>
                    <li>{t('terms.user_provide_info')}</li>
                    <li>{t('terms.agree_to_info_processing')}</li>
                    <li>
                        <p>
                            {t('terms.personal_data_processing_note')}
                        </p>
                        <ol>
                            <li>
                                <Trans
                                    i18nKey="terms.ads"
                                    components={[
                                        <a href="http://travelask.ru/contact" />
                                    ]} />
                            </li>
                        </ol>
                    </li>
                    <li>{t('terms.user_consents_to_collection_of_cookies')}</li>
                    <li>
                        <Trans
                            i18nKey={'terms.site_using_user_ip'}
                            components={[
                                <a href="http://travelask.ru">euphora.travelask.ru</a>
                            ]} />
                    </li>
                    <li>{t('terms.site_is_not_responsible_for_user_info')}</li>
                    <li>
                        <a href="http://travelask.ru/terms">http://travelask.ru/terms</a>
                    </li>
                </ol>

                <h3>
                    <strong>{t('terms.cookie')}</strong>
                </h3>

                <p>
                    <br />
                    {t('terms.cookie_note')}
                </p>
                <p>
                    {t('terms.cookie_using')}
                </p>
                
                <ul>
                    <li>
                        {t('terms.cookie_sessions')}
                    </li>
                    <li>
                        {t('terms.cookie_remember_me')}
                    </li>
                    <li>
                        {t('terms.cookie_stats_collecting')}
                    </li>
                    <li>
                        {t('terms.cookie_third_party')}
                    </li>
                </ul>
                
                <p>
                    {t('terms.cookie_security')}
                </p>

                <p>
                    {t('terms.cookie_disable')}
                </p>
            </div>

        </>
    );
};

export default TermsOfService;
